import { get } from "lodash";
import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import { TranscriptFileUploadInputComponent } from "./TranscriptFileUploadInputComponent";

interface TranscriptFileUploadProps {
  name: string;
  placeholder: string;
  rules: RegisterOptions;
}

export const TranscriptFileUploadInput = ({
  name,
  rules,
  placeholder,
  ...passThroughProps
}: TranscriptFileUploadProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);
  const errorMessage = typeof error?.message === "string" ? error.message : "";

  return (
    <Controller<Record<string, string>>
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange } }) => (
        <TranscriptFileUploadInputComponent
          name={name}
          onChange={onChange}
          errorMessage={errorMessage}
          placeholder={placeholder}
          {...passThroughProps}
        />
      )}
    />
  );
};
